require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 266
// module chunks = 0